import ActionPerformerHelper from "@/utils/moreMenu/ActionPerfomerHelper.ts";
import {WidgetsPresenter} from "@/utils/presenters/interfaces.ts";
import NaMaMetaData = namaTypes.NaMaMetaData;

export default class TaskPerformerHelper extends ActionPerformerHelper {
  addContextFieldsToAction(contextFieldIds: string[], contextRow: number, contextFields: Record<string, namaTypes.GenericValue>): void {
  }

  entityMetadata(): NaMaMetaData {
    return {};
  }

  fetchPresenter(): WidgetsPresenter {
    return {} as WidgetsPresenter;
  }

  getEntityType(): string {
    return "";
  }

}
